import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import {
    syncFcmToken,
    startForegroundNotifications,
    listenNotificationNavigation,
} from '../../services/notifications/FCMService';

/**
 * Dipasang SEKALI di App (tidak menampilkan apa pun):
 * - sinkron token FCM setiap login / aplikasi dibuka (bila izin sudah diberikan),
 * - tampilkan notifikasi saat aplikasi sedang terbuka,
 * - pindah halaman saat notifikasi diketuk ketika aplikasi sudah terbuka.
 */
export const PushNotificationManager: React.FC = () => {
    const { authUser } = useAuth();
    const uid = authUser?.uid;

    useEffect(() => listenNotificationNavigation(), []);

    useEffect(() => {
        if (!uid) return;
        let stop: (() => void) | null = null;
        let cancelled = false;

        syncFcmToken().catch(() => null);
        startForegroundNotifications()
            .then(unsub => {
                if (cancelled) unsub();
                else stop = unsub;
            })
            .catch(() => null);

        return () => {
            cancelled = true;
            stop?.();
        };
    }, [uid]);

    return null;
};
